var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoto(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#7C7C7C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0c.821 0 1.5.659 1.5 1.475v9.035c0 .815-.679 1.49-1.5 1.49h-12C.679 12 0 11.325 0 10.51V1.49C0 .675.679 0 1.5 0zM1.153 6.588v3.922c0 .188.158.345.347.345h12c.19 0 .347-.157.332-.33V6.604c-.458 0-.916.031-1.39.094-1.279.173-2.479.596-3.41 1.192.442.267.884.55 1.279.863.252.188.3.549.11.8-.11.141-.284.22-.458.22-.126 0-.237-.048-.347-.126-.569-.44-1.2-.847-1.88-1.208-.6-.33-1.247-.627-1.925-.878-1.58-.596-3.19-.926-4.658-.973zM13.5 1.13h-12c-.19 0-.347.157-.347.346v3.968c1.626.047 3.347.408 5.068 1.035.6.236 1.184.487 1.721.77 1.121-.864 2.684-1.475 4.358-1.71.521-.08 1.042-.11 1.547-.11V1.474c0-.189-.158-.346-.347-.346zm-2.25.933c.621 0 1.125.504 1.125 1.126 0 .62-.504 1.124-1.125 1.124s-1.125-.503-1.125-1.125c0-.62.504-1.124 1.125-1.124z",
    transform: "translate(-544 -254) translate(544 254)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.6d8f44ad.svg";
export { ForwardRef as ReactComponent };